import { useEffect } from 'react';

import { Tab, Tabs } from '@mui/material';

import { useAppDispatch, useAppSelector } from 'state/hooks';
import {
  selectWorkflowTravelTimeToolbarUIMode,
  setWorkflowTravelTimeToolbarUIMode,
} from 'state/workflowSlice';

import { TaskBarTabPanel } from 'features/task_bar/TaskBarTabs';

import { BookmarkToolbar } from './BookmarkToolbar';
import { SavedRoutesToolbar } from './SavedRoutesToolbar';
import { SavedRoutesVariant, WorkflowTravelTimeToolbarTab } from './utils';

import styles from '../task_bar/TaskBarTabs.module.css';

interface Props {
  fullHeight?: boolean;
  variant: SavedRoutesVariant;
}

export function WorkflowTravelTimeToolbar({
  fullHeight = false,
  variant,
}: Props) {
  const dispatch = useAppDispatch();
  const uiMode = useAppSelector(selectWorkflowTravelTimeToolbarUIMode);

  const TABS = Object.values(WorkflowTravelTimeToolbarTab);
  const setTab = (index: number) => {
    dispatch(
      setWorkflowTravelTimeToolbarUIMode(
        TABS[index] || WorkflowTravelTimeToolbarTab.SavedRoutes,
      ),
    );
  };

  useEffect(() => {
    dispatch(
      setWorkflowTravelTimeToolbarUIMode(
        uiMode || WorkflowTravelTimeToolbarTab.SavedRoutes,
      ),
    );
  }, [uiMode]);

  if (variant === 'modal')
    return (
      <TaskBarTabPanel
        value={uiMode}
        index={WorkflowTravelTimeToolbarTab.SavedRoutes}
        extraClass={!fullHeight && styles.saved_routes_tab}
      >
        <SavedRoutesToolbar modern variant={variant} />
      </TaskBarTabPanel>
    );
  else
    return (
      <>
        <Tabs
          value={TABS.indexOf(
            uiMode || WorkflowTravelTimeToolbarTab.SavedRoutes,
          )}
          onChange={(ev, index) => setTab(index)}
          className={styles.taskbar_top_tabs}
        >
          <Tab label="Saved Routes" />
          <Tab label="Locations" />
        </Tabs>
        <TaskBarTabPanel
          value={uiMode}
          index={WorkflowTravelTimeToolbarTab.SavedRoutes}
          extraClass={!fullHeight && styles.saved_routes_tab}
        >
          <SavedRoutesToolbar />
        </TaskBarTabPanel>
        <TaskBarTabPanel
          value={uiMode}
          index={WorkflowTravelTimeToolbarTab.Locations}
          extraClass={!fullHeight && styles.locations_tab}
        >
          <BookmarkToolbar showTitle={false} />
        </TaskBarTabPanel>
      </>
    );
}
